import { api } from "boot/axios";

export default () => {
  //get All Announcement

  const getAllAnnouncement = async () => {
    try {
      const data = await api.get("/report/");

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //get stock Announcement

  const getStockAnnouncement = async (symbol) => {
    try {
      const data = await api.get(`/report/?symbol=${symbol}`);

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };
  //get Dashboard Announcement

  const getDashboardAnnouncement = async (symbol) => {
    try {
      const data = await api.get(`/report/?feeds=true`);

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };
  return {
    getAllAnnouncement,
    getStockAnnouncement,
    getDashboardAnnouncement,
  };
};
